import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchPaymentMethodList } from '../../../services/payment_methods';

function usePaymentMethod() {
	const [paymentMethodParams, setPaymentMethodParams] = useState({
		page: 1,
		limit: 20,
		search: '',
	});
	const [searchPaymentMethod, setSearchPaymentMethod] = useState('');
	const [paymentMethodList, setPaymentMethodList] = useState([]);

	const handleFetchPaymentMethod = useCallback(async () => {
		try {
			const data = await fetchPaymentMethodList(paymentMethodParams);
			const paymentMethodOptionList = data?.paymentMethods?.map((pm) => {
				return {
					key: pm?.payment_method_id,
					value: pm?.payment_method_name,
				};
			});
			setPaymentMethodList(paymentMethodOptionList);
		} catch (error) {
			toast.error('Something went wrong! While Fetching the Payment Methods List.');
		}
	}, [paymentMethodParams]);

	useEffect(() => {
		handleFetchPaymentMethod();
	}, [paymentMethodParams?.search]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setPaymentMethodParams((prev) => ({
				...prev,
				search: searchPaymentMethod,
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchPaymentMethod]);

	return {
		paymentMethodList,
		setPaymentMethodList,
		setPaymentMethodParams,
		setSearchPaymentMethod,
	};
}

export default usePaymentMethod;
